import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { adminLogin, fetchMe } from "@/lib/api";

const TOKEN_KEY = "cjb_admin_token";
const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(!!localStorage.getItem(TOKEN_KEY));

  useEffect(() => {
    let active = true;
    if (!token) { setAdmin(null); setLoading(false); return; }
    setLoading(true);
    fetchMe(token)
      .then((a) => { if (active) setAdmin(a); })
      .catch(() => { if (active) { localStorage.removeItem(TOKEN_KEY); setToken(null); setAdmin(null); } })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [token]);

  const login = useCallback(async (email, password) => {
    const data = await adminLogin(email, password);
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setAdmin({ email: data.email, name: data.name, role: "admin" });
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setAdmin(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ token, admin, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
